<template>
    <v-container flud>
        <v-row>
            <v-col
                    md="6"
                    offset-md="3">
                <p class="headline text-sm-center">{{ promo.title }} @ {{ promo.locationName }}</p>
                <v-divider class="my-3"></v-divider>
                <p>Location : {{ promo.locationName }}</p>
                <p>Details : {{ promo.description }}</p>
                <v-form
                        ref="form"
                        @submit.enter.prevent
               >
                    <v-text-field
                            v-model="email"
                            :error-messages="emailErrors"
                            label="E-mail"
                            required
                            @input="$v.email.$touch()"
                            @blur="$v.email.$touch()"
                    ></v-text-field>
                    <v-btn class="mt-4 mr-4" color="warning" @click="submitPromo()">submit</v-btn>
                    <v-btn
                            color="info"
                            @click="alert = !alert"
                            text
                            class="mt-4"
                    >
                        Why do I need this?
                    </v-btn>
                    <v-alert
                            :value="alert"
                            color="info"
                            dismissible
                            dark
                            border="top"
                            icon="mdi-alert"
                            transition="scale-transition"
                            class="mt-4"
                    >
                       We need your email so we can send you the Promo. We also
                        use email to validate the platform so we can get more partners, which means even more Promos for you.
                        We promise not to spam you.
                    </v-alert>
                </v-form>
            </v-col>
        </v-row>
    </v-container>
</template>

<script>
    import { validationMixin } from 'vuelidate'
    import { required, email } from 'vuelidate/lib/validators'
    // import PromoService from '../services/PromoService'

    export default {
        mixins: [validationMixin],
        validations: {
            email: {required, email}
        },
        name: "PromoDetail",
        props: ['promo'],
        data() {
            return {
                email: '',
                emailRules: [
                    v => !!v || 'E-mail is required',
                    v => /.+@.+/.test(v) || 'E-mail must be valid',
                ],
                alert: false,
                errors: true
            }
        },
        computed: {
            emailErrors() {
                const errors = []
                if (!this.$v.email.$dirty) return errors
                !this.$v.email.email && errors.push('Must be valid e-mail')
                !this.$v.email.required && errors.push('E-mail is required')
                return errors
            },
        },
        methods: {
            submitPromo() {

                this.$v.$touch();
                this.errors = this.$v.email.$anyError

                if (this.errors == true) {
                console.log('error on page')}

                else {
                    let formData = new FormData();
                    formData.append("email", this.email);
                    formData.append("promoId", this.promo.id)
                    // axios.post("/about", formData);
                    for (var value of formData.values()) {
                        console.log(value)
                    }
                    for (var key of formData.keys()) {
                        console.log(key)
                    }
                    this.$router.push({name: 'PromoSuccess'})
                }

                // PromoService.postPromo(formData)
                // .then(function (response) {
                // if (response.status === 200) {
                //     this.$router.push({path: '/'})
                // }
            },
        }
    }
</script>

<style scoped>

</style>